import createHeartbeat from 'redux-heartbeat'

import { isWhitelisted } from './actions/matchers'
import { HEARTBEAT_NAME } from './model'

export const heartbeat = createHeartbeat(4000, undefined, (_, action) => isWhitelisted(action), false, HEARTBEAT_NAME)

export default heartbeat
